<section id="content">
  <div class="content-wrap m-0 p-0">
    <div class="parallax">
      <div class="section my-0 p-t-65 m-b-60">
        <div class="container">
          <div class="row">
            <div class="col-12 p-l-0 p-r-0">
              <h3 class="border-page-title">{{ 'Register' | translate }}</h3>
            </div>
          </div>
          <div class="row col-mb-100">
            <div class="ma-box center-container" [ngStyle]="isQP23 ? { color: 'var(--mainColor26)' } : {}">
              <app-signup-form
                presentation="page"
                (success)="onSignupSuccess($event)"
                (error)="onSignupError($event)"
                (loginClick)="onLogin()"
              ></app-signup-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
